import { render, staticRenderFns } from "./DocumentTile.vue?vue&type=template&id=18ee95a0&scoped=true&"
import script from "./DocumentTile.vue?vue&type=script&lang=ts&"
export * from "./DocumentTile.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTile.vue?vue&type=style&index=0&id=18ee95a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ee95a0",
  null
  
)

component.options.__file = "DocumentTile.vue"
export default component.exports